import { render, staticRenderFns } from "./month.vue?vue&type=template&id=870e2dde&scoped=true&lang=html"
import script from "./month.vue?vue&type=script&lang=js"
export * from "./month.vue?vue&type=script&lang=js"
import style0 from "./month.vue?vue&type=style&index=0&id=870e2dde&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870e2dde",
  null
  
)

export default component.exports